import CommonHero from "../components/common/CommonHero";
import aboutUs_img from "../assets/img/aboutUs_img.png";
import HappyClients from "../components/common/HappyClients";
import GetTheBestTravelDeal from "../components/common/GetTheBestTravelDeal";
import Discover from "../components/about-us/Discover";
import Destination from "../components/about-us/Destination";
import TravelPartner from "../components/about-us/TravelPartner";
import { useEffect } from "react";

const AboutPage = () => {
  useEffect(() => {
    document.getElementById("title-page").innerHTML = "TripNest | About us";
  }, []);
  return (
    <div>
      <CommonHero imgUrl={aboutUs_img} text="About Us" />
      <Discover />
      <Destination />
      <TravelPartner />
      <HappyClients />
      <GetTheBestTravelDeal />
    </div>
  );
};

export default AboutPage;
